type ResourceGuardPattern = string | RegExp

type ResourceGuardGlobal = {
  configure?: (options: {
    optionalScriptPatterns?: ResourceGuardPattern[]
  }) => void
}

declare global {
  interface Window {
    __BALDR_RESOURCE_GUARD__?: ResourceGuardGlobal
  }
}

const OPTIONAL_SCRIPT_PATTERNS: ResourceGuardPattern[] = [
  /clarity\.ms\//i,
  /connect\.facebook\.net\//i,
  /googleads/i,
  /googletagmanager\.com\//i,
  /google/i,
]

export const initResourceGuard = () => {
  const guard = window.__BALDR_RESOURCE_GUARD__
  if (!guard) {
    return
  }

  guard.configure?.({
    optionalScriptPatterns: OPTIONAL_SCRIPT_PATTERNS,
  })
}
